const trustItems = [
  { icon: 'ri-medal-line', label: 'Owens Corning Platinum Preferred Contractor' },
  { icon: 'ri-calendar-line', label: 'Serving Since 1998' },
  { icon: 'ri-group-line', label: '20,000+ Satisfied Property Owners' },
  { icon: 'ri-time-line', label: '100+ Years Combined Experience' },
  { icon: 'ri-shield-check-line', label: 'Licensed &amp; Insured' },
];

export default function TrustBar() {
  return (
    <section className="bg-[#1a1a1a] border-y border-white/5 py-6">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-0 md:justify-between">
          {trustItems.map((item, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center bg-[#c0392b]/15 rounded-full">
                <i className={`${item.icon} text-[#c0392b] text-sm`}></i>
              </div>
              <span
                className="text-white/80 text-xs md:text-sm font-medium whitespace-nowrap"
                dangerouslySetInnerHTML={{ __html: item.label }}
              />
              {i < trustItems.length - 1 && (
                <div className="hidden md:block w-px h-6 bg-white/10 ml-6"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
